/** @flow */

export default {
  en: {
    CHANGE_LOG: "Change Log",
    CHANGE_LOG_EXPAND_ALL: "Expand All",
    CHANGE_LOG_COLLAPSE_ALL: "Collapse All",
    CHANGE_LOG_COL_OPERATION: "Operation",
    CHANGE_LOG_COL_RECORD: "Record",
    CHANGE_LOG_COL_UPDATED_BY: "Updated By",
    CHANGE_LOG_COL_UPDATED_AT: "Updated At",
    CHANGE_LOG_COL_PROPERTY: "Property",
    CHANGE_LOG_COL_FROM: "From",
    CHANGE_LOG_COL_TO: "To",
    UPDATED_BY_SIP_FILE: "SIP File ({id})",
    THIRD_PARTY_INTEGRATION: "3rd Party Integration",
    SYSTEM: "System",
  },
};
